import React, { useState, useEffect } from 'react';
import LabelledTextField from '../LabelledTextField';
import { dateOptions } from '../../utils/dates';

const StripeSubscriptionDetials = ({subscription}) => {
  return (
    <div className="card card-spaced">
      <h4>{subscription.name}</h4>
      <LabelledTextField label="Subscription ID" text={subscription.subscriptionId} />
      <LabelledTextField label="Status" text={subscription.status} />
      <LabelledTextField label="Last Payment" text={subscription.lastPaymentDate ? new Date(subscription.lastPaymentDate).toLocaleDateString('en-US', dateOptions) : ''} />
      <LabelledTextField label="Amount" text={subscription.lastPaymentAmount ? '$' + subscription.lastPaymentAmount.toFixed(2) : ''} />
      {subscription.nextPaymentDate && (
        <LabelledTextField label="Next Payment" text={subscription.nextPaymentDate ? new Date(subscription.nextPaymentDate).toLocaleDateString('en-US', dateOptions) : ''} />
      )}
      {subscription.cancelAtDate && (
        <LabelledTextField label="Canceling At" text={subscription.cancelAtDate ? new Date(subscription.cancelAtDate).toLocaleDateString('en-US', dateOptions) : ''} />
      )}
      <div className="form-actions">
        <a className='link' target="_blank" href={subscription.portalUrl}>Details</a>
      </div>
    </div>
  );
};

export default StripeSubscriptionDetials;